<template>
  <section id="entry-index" class="layout-section -bg-shade -search-top">
    <p v-if="$wp.secondaryDataLoaded && !publicationsPage.length" class="layout-section__heading">Aucun résultat</p>

    <div v-else class="card-article">
      <DemoGridArticlesSingle
        v-for="(publication, index) in publicationsPage"
        :key="getEntryKey(publication)"
        v-scroll:reveal="{ delay: (index % 3) * 75, offset: 0 }"
        route-name="publication-single"
        slug-key="publicationSlug"
        :slug="publication.slug"
        :type="publication.type"
      />
    </div>

    <PagePickerQuery :total-pages="totalPages" />
  </section>
</template>

<script>
import DemoGridArticlesSingle from '../../component-demo/partials/DemoGridArticlesSingle.vue'
import { normalizeForSearch, safeArray } from '@/helpers/search-helpers'

const perPage = 18

export default {
  name: 'PublicationIndex',
  components: { DemoGridArticlesSingle },
  computed: {
    searchTerm() {
      return normalizeForSearch(this.$route.query.search || '')
    },
    currentKeywords() {
      if (!this.$route.query.keywords) return []
      return Array.isArray(this.$route.query.keywords) ? this.$route.query.keywords : [this.$route.query.keywords]
    },
    currentPage() {
      return this.$route.query.page ? Math.max(parseInt(this.$route.query.page) - 1, 0) : 0
    },
    currentType() {
      return this.$route.query.type || null
    },
    allPublications() {
      return this.$wp.restPublications || []
    },
    filteredPublications() {
      const filteredPublications = !this.currentType
        ? this.allPublications
        : this.allPublications.filter(pub => pub.type === this.currentType)

      return this.filterKeywordMatches(filteredPublications)
    },
    matchedPublications() {
      if (!this.searchTerm) return this.filteredPublications

      const results = this.filteredPublications.filter(({ content, title, keywords = [], authors = [] }) => {
        const searchableContent = [
          normalizeForSearch(content),
          normalizeForSearch(title),
          normalizeForSearch(
            safeArray(keywords)
              .map(id => this.$wp.keywordsById[id] && this.$wp.keywordsById[id].name)
              .join(' ')
          ),
          normalizeForSearch(
            safeArray(authors)
              .map(id => this.$wp.authorsById[id] && this.$wp.authorsById[id].name)
              .join(' ')
          )
        ]

        return searchableContent.join(' ').includes(this.searchTerm)
      })

      return results
    },
    publicationsPage() {
      return this.matchedPublications.slice(this.currentPage * perPage, (this.currentPage + 1) * perPage)
    },
    totalPages() {
      return Math.ceil(this.matchedPublications.length / perPage)
    }
  },
  methods: {
    getEntryKey(entry) {
      const key = entry.id || `${entry.slug}-${entry.type}`
      return `${key}-${JSON.stringify(this.$route.query)}`
    },
    filterKeywordMatches(entries) {
      if (!this.currentKeywords.length) return entries

      return entries.filter(entry => {
        if (!entry || !entry.keywords) return false

        return safeArray(entry.keywords)
          .map(id => this.$wp.keywordsById[id] && this.$wp.keywordsById[id].slug)
          .filter(Boolean)
          .some(slug => this.currentKeywords.includes(slug))
      })
    }
  }
}
</script>
